import React from 'react';
import { withPrefix, Link } from 'gatsby';

const Customers = (props) => {
  return (
    <section className="customers">
      <div className="container">
        <div className="columns">
          <div className="column is-one-third">
            <div className="card">
              <div className="card-image">
                <figure className="image is-4by3">
                  <img src={withPrefix('/img/'+ props.customers.customer1Image.relativePath)} alt="Customer Image" />
                </figure>
              </div>
              <div className="card-content">
                <div className="media">
                  <div className="media-content">
                    <p className="title is-4">{ props.customers.customer1Headline }</p>
                  </div>
                </div>
                <div className="content">
                  { props.customers.customer1Text }
                </div>
              </div>
            </div>
          </div>
          <div className="column is-one-third">
            <div className="card">
              <div className="card-image">
                <figure className="image is-4by3">
                  <img src={withPrefix('/img/'+ props.customers.customer2Image.relativePath)} alt="Customer Image" />
                </figure>
              </div>
              <div className="card-content">
                <div className="media">
                  <div className="media-content">
                    <p className="title is-4">{ props.customers.customer2Headline }</p>
                  </div>
                </div>
                <div className="content">
                  { props.customers.customer2Text }
                </div>
              </div>
            </div>
          </div>
          <div className="column is-one-third">
            <div className="card">
              <div className="card-image">
                <figure className="image is-4by3">
                  <img src={withPrefix('/img/'+ props.customers.customer3Image.relativePath)} alt="Customer Image" />
                </figure>
              </div>
              <div className="card-content">
                <div className="media">
                  <div className="media-content">
                    <p className="title is-4">{ props.customers.customer3Headline }</p>
                  </div>
                </div>
                <div className="content">
                  { props.customers.customer3Text }
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="columns">
          <div className="column is-full">
            <div className="columns logo-inner">
              <div className="logo-slider">
                <div className="logos" width={ 1200 / 5 * 31 + "px"}>
                  <div className="logo"><img src={withPrefix('/img/gpi_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/hauser_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/keba_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/miba_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/kuka-neu.svg')} alt="Logo" /></div>

                  <div className="logo"><img src={withPrefix('/img/intersport_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/haidlmair_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/erema_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/andmetics_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/anton_paar_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/Brucha_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/gmundner_keramik_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/grosarl_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/magenta_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/Wings_for_life_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/eat_happy_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/green_edge_cloud_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/nachrichten_at_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/Alpla_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/CADS.Additive_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/stadt_linz_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/welser_profile_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/logo_caritas.png')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/logo_helvetia.png')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/logo_hlw_steyr.png')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/logo_infoniqa.png')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/logo_lsz.png')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/logo_magenta.png')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/logo_mm.png')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/logo_mohrenwirt.png')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/logo_prefa.png')} alt="Logo" /></div>

                  <div className="logo"><img src={withPrefix('/img/gpi_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/hauser_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/keba_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/miba_tinted.svg')} alt="Logo" /></div>
                  <div className="logo"><img src={withPrefix('/img/kuka-neu.svg')} alt="Logo" /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Link to={ props.locale === "en" ? "/contact" : "/de/contact" } className="button is-rounded customers-button">{ props.customers.customersButton }</Link>
      </div>
    </section>
  );
};

export default Customers;
